exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-altaTable{background-color:#f4cdcd;border:1px solid #f6adad}.bg-mediaTable{background-color:#fff2cc;border:1px solid #f6db8a}.bg-destacadoTable{background-color:#d9ead3;border:1px solid #c3eab5}.bg-sinrangoTable{background-color:#eceeec;border:1px solid #d4d5d3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49b048d7","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/frpm/table.vue
// module id = 2139
// module chunks = 2